import { getFaviconServiceUrl } from "../../helpers/favicon";
import { isExternalLink, normalizeLink } from "./utils";
export function linkMarkSpec() {
    return {
        link: {
            attrs: {
                href: {},
            },
            content: "inline+",
            inclusive: false,
            parseDOM: [
                {
                    tag: "a[href]",
                    getAttrs(dom) {
                        return { href: dom.getAttribute("href") };
                    },
                },
            ],
            toDOM(node) {
                const { href } = node.attrs;
                const faviconLink = getFaviconServiceUrl(href);
                // Only render the favicon for external links.
                const style = isExternalLink(href)
                    ? {
                        style: `--favicon: url(${faviconLink});`,
                    }
                    : {};
                return [
                    "a",
                    {
                        href: normalizeLink(href),
                        target: "_blank",
                        class: "external-link",
                        ...style,
                    },
                    0,
                ];
            },
        },
    };
}
